export default __webpack_public_path__ + "static/media/shokiBG.c0149bbd.png";